"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat = void 0;
var three_1 = require("three");
var CSS3DRenderer_1 = require("three/examples/jsm/renderers/CSS3DRenderer");
var util_1 = require("../util");
var function_1 = require("../util/function");
var Chat = /** @class */ (function (_super) {
    __extends(Chat, _super);
    function Chat(base) {
        var _this = _super.call(this) || this;
        _this.base = base;
        _this.offset = 1.7;
        _this.pos = new three_1.Vector3(0, 0, _this.offset);
        _this.normal = new three_1.Vector3(0, 0, 1);
        _this.cNormal = new three_1.Vector3();
        _this.cPos = new three_1.Vector3();
        _this.m4 = new three_1.Matrix4();
        _this.setElement();
        return _this;
    }
    Chat.prototype.setElement = function () {
        this.element = this.base.domBundle.querySelector('#chat-main-cube');
        this.chatMainInner = this.element.querySelector('#chat-main-inner');
        this.loginGuide = this.element.querySelector('#login-guide');
        this.guestList = this.element.querySelector('#guest-list');
        this.loginGuideBtn = this.element.querySelector('#login-guide-button');
        this.object = new CSS3DRenderer_1.CSS3DObject(this.element);
        this.object.position.set(0, 0, this.offset);
        this.object.scale.set(1 / 160, 1 / 160, 1);
        this.bindElementEvents();
    };
    Chat.prototype.showScreen = function (target) {
        var _this = this;
        var hideClass = 'chat-main__inner--hide';
        var targets = ['chatMainInner', 'loginGuide', 'guestList'];
        this[target].classList.remove(hideClass);
        targets.filter(function (val) { return val !== target; }).forEach(function (unchosen) {
            var _a;
            (_a = _this[unchosen]) === null || _a === void 0 ? void 0 : _a.classList.add(hideClass);
        });
    };
    Chat.prototype.refreshGuestList = function (list) {
        var containerEle = this.guestList.querySelector('#guest-list-container');
        containerEle.innerHTML = '';
        var total = '';
        var transitionGap = 200;
        list.forEach(function (guest, index) {
            var item = "\n           <li class=\"guest-list__li guest\" style=\"animation-delay:".concat(transitionGap * index, "ms\">\n                <div class=\"guest__name\">").concat(guest.username, "</div>\n            </li>\n            ");
            total += item;
        });
        containerEle.innerHTML = total;
    };
    Chat.prototype.bindElementEvents = function () {
        var _this = this;
        this.loginGuideBtn.addEventListener('pointerdown', function () {
            _this.trigger('cube-login-button-click');
        });
    };
    Chat.prototype.setGuestNumber = function (data) {
        var containerEle = this.guestList.querySelector('#guest-number');
        containerEle.innerHTML = "NOW ONLINE: ".concat(data);
    };
    Chat.prototype.update = function () {
        (0, function_1.updateOcclude)(this);
    };
    return Chat;
}(util_1.EventEmitter));
exports.Chat = Chat;
